import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages/home/Home';
import Fiche from './pages/fiche/Fiche';
import Navbar from './components/navbar/Navbar';
import './App.css';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Infoia from './components/infoia/Infoia';

import matomoEvt from './service/MatomoService';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
          showIa: false,
          showConnexion: true,
          email: '',
          numInterloc: ''
        };
      }

    componentDidMount() {
        fetch('/api/connect/status')
            .then(response => {
                if (response.status !== 200) {
                    // console.log('User non connecté ou non connu')
                    return response.text();
                }
                return response.json();
            })
            .then(content => {
              if (content.connectStatus !== undefined && (content.connectStatus === 1 || content.connectStatus === 2)) {
                this.setState({ showConnexion: false });
              }
              if (content.connectStatus !== undefined && content.connectStatus === 2) {
                  this.setState({ showIa: true });
              }
              // Connecté mais sans accès IA : on retire le drapeau (aucun bouton IA à indiquer)
              if (content.connectStatus === 1) {
                  sessionStorage.removeItem('openIaAfterLogin');
              }
              if (content.email !== undefined) {
                this.setState({ email: content.email });
              }
              if (content.numInterloc !== undefined && content.numInterloc !== 'NO_CRM_CONTACT_NUMBER') {
                this.setState({ numInterloc: content.numInterloc });
                window.matomo_ct_numrodinterlocuteur = content.numInterloc;
              }
            })
            .catch(error => console.error('Error fetching data:', error));
    }

  handleOpen = () => {
    matomoEvt("Affichage incitation connexion", "none", "none")
  }

  handleConnect = (url) => {
    // On mémorise que la connexion vient d'être lancée, afin d'ouvrir l'IA au retour si l'utilisateur y a accès
    sessionStorage.setItem('openIaAfterLogin', 'true');
    matomoEvt("Me connecter", url, "none")
  }

  handleCreateAccount = (url) => {
    matomoEvt("Créer un compte", url, "none")
  }

  render() {
    return (
      <Router>
        {!this.state.showIa && (
          <Infoia createLink={window.env.REACT_APP_WORDPRESS_CREATE_ACCOUNT_URI} 
            connectLink="/api/login" 
            onOpen={this.handleOpen}
            onConnect={this.handleConnect.bind(this)} 
            onCreateAccount={this.handleCreateAccount.bind(this)} 
          >
          </Infoia>)}
        <Header showConnexion={this.state.showConnexion} onConnect={this.handleConnect.bind(this)} />
        <Navbar />
        <div className='row container'>
      
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/fiche/:id' element={<Fiche />} />
            </Routes>

        </div>
        <Footer />
      </Router>
    );
  }
}
export default App;
